import PongText from '../components/ui/pong-text';
import { resolveUrl } from '../lib/api';
import { useSiteSettings } from '../lib/content';

export default function HomePage() {
  const { settings } = useSiteSettings();
  const name = settings?.display_name?.trim() || 'Ch Varun';
  const tagline = settings?.tagline?.trim() || '';
  const location = settings?.location?.trim() || '';
  const resumeUrl = resolveUrl(settings?.resume_url);

  return (
    <section className="home">
      <h1 className="sr-only">
        {name}{tagline ? ` — ${tagline}` : ' — AI Engineer & Developer'}
        {location ? ` · ${location}` : ''}
      </h1>

      <div className="hero-stage" aria-label="Pong hero">
        {/* Corner ticks */}
        <div className="hero-corners" aria-hidden="true">
          <div className="hero-corner tl"><span className="vtick" /><span className="tick" /></div>
          <div className="hero-corner tr"><span className="tick" /><span className="vtick" /></div>
          <div className="hero-corner bl"><span className="tick" /><span className="vtick" /></div>
          <div className="hero-corner br"><span className="vtick" /><span className="tick" /></div>
        </div>

        {/* Pong canvas — renders Ch Varun, "I build with love/hate", and quote */}
        <PongText className="pong-canvas" name={name} tagline={tagline} />
      </div>

      {/* Vertical socials */}
      <nav className="socials" aria-label="Social">
        <a href="https://github.com/TheCoder30ec4" title="GitHub" aria-label="GitHub" target="_blank" rel="noreferrer">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 .5C5.6.5.5 5.6.5 12c0 5.1 3.3 9.4 7.9 10.9.6.1.8-.3.8-.6v-2c-3.2.7-3.9-1.5-3.9-1.5-.5-1.4-1.3-1.7-1.3-1.7-1.1-.7.1-.7.1-.7 1.2.1 1.8 1.2 1.8 1.2 1 1.8 2.7 1.3 3.4 1 .1-.8.4-1.3.8-1.6-2.6-.3-5.3-1.3-5.3-5.7 0-1.3.5-2.3 1.2-3.1-.1-.3-.5-1.5.1-3.1 0 0 1-.3 3.3 1.2.9-.3 2-.4 3-.4s2.1.1 3 .4c2.3-1.5 3.3-1.2 3.3-1.2.7 1.6.2 2.8.1 3.1.8.8 1.2 1.9 1.2 3.1 0 4.5-2.7 5.4-5.3 5.7.4.4.8 1.1.8 2.2v3.3c0 .3.2.7.8.6 4.6-1.5 7.9-5.8 7.9-10.9C23.5 5.6 18.4.5 12 .5z" /></svg>
        </a>
        <a href="https://www.linkedin.com/in/ch-varun/" title="LinkedIn" aria-label="LinkedIn" target="_blank" rel="noreferrer">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.5 2h-17C2.7 2 2 2.7 2 3.5v17c0 .8.7 1.5 1.5 1.5h17c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5zM8 19H5V9h3v10zM6.5 7.7C5.5 7.7 4.7 6.9 4.7 6S5.5 4.3 6.5 4.3 8.3 5.1 8.3 6 7.5 7.7 6.5 7.7zM19 19h-3v-5.3c0-1.3-.5-2.1-1.6-2.1-1.2 0-1.9.8-1.9 2.1V19h-3V9h3v1.4c.4-.7 1.5-1.6 3.1-1.6 2.3 0 3.5 1.4 3.5 4.2V19z" /></svg>
        </a>
        <a href="https://twitter.com/chvarun" title="Twitter" aria-label="X / Twitter" target="_blank" rel="noreferrer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
        </a>
        <a href="mailto:varun30ec4@gmail.com" title="Email" aria-label="Email">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></svg>
        </a>
        {resumeUrl && (
          <a href={resumeUrl} title="Resume" aria-label="Download resume" target="_blank" rel="noreferrer" style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.1em' }}>CV</a>
        )}
      </nav>

      {/* Scroll cue */}
      <div className="scroll-cue" aria-hidden="true">scroll · explore</div>

    </section>
  );
}
